/*!
* Subscription form
*/
/* globals ga*/

import {submitHandler} from '../utils/submit-handler';
import messages from '../messages/common';
import {showResult} from '../utils/response-notice';

const wrapForm = '.subscribe-form';
const message = messages();

/**
 * Validate adn send form
 */
let initValidate = ($wrapElem) => {
    $wrapElem.find('form')
        .validate({
            focusCleanup: true,
            ignore: '[name="subscribe[text]"]',
            // onkeyup: false,
            rules: {
                'subscribe[name]': {
                    required: true,
                },
                'subscribe[email]': {
                    required: true,
                    email: true,
                },
            },
            messages: {
                'subscribe[name]': {
                    required: message.empty,
                },
                'subscribe[email]': {
                    required: message.empty,
                    email: message.incorrectEmail,
                },
            },
            submitHandler() {
                let $form = $wrapElem.find('form');

                submitHandler($form)
                    .then((json) => {
                        if (json.success) {
                            if (typeof ga !== 'undefined') {
                                ga('send', 'event', 'Email', 'Subscribe', 'General', 1);
                            }
                        }
                        window.location = 'https://top3dexpo.ru/thank-you/';
                        // window.open('https://top3dexpo.ru/thank-you/', '_blank');
                        // showResult($form, json, {}, 'SuccessfulRegistration');
                    });
            },
            errorClass: 'invalid',
            errorPlacement(error, Element) {
                error.addClass('error');
                error.wrapInner($('<div>').addClass('error-inner'));
                Element.after(error);
            },
        });
};

/**
 * Init subscribe form
 */
let init = () => {
    let $wrapElem = $(wrapForm);

    if (!$wrapElem.length) {
        return;
    }

    $wrapElem.each((i, elem) => {
        initValidate($(elem));
    });
};

export {init as initSubscribe};
